var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings && _vm.settings.content)?_c('div',{class:[_vm.settings.textColor, _vm.settings.textAlign],domProps:{"innerHTML":_vm._s(_vm.markdownToDisplay)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }